import { isGoogleVignetteShowing } from "./google_vignette"

// Google's vignette ad intercepts a link click, parks the page on
// #google_vignette, and on Close replays the click while its scroll-lock
// release (window.scrollTo to the old position) is still pending on a timer.
// Under Turbo the document survives the visit, so that restore lands on the
// next page. Cancelling turbo:click hands the replayed click to the browser,
// giving Google the full page load it was written for.
export const bypassTurboForVignetteClicks = () => {
  document.addEventListener("turbo:click", (event) => {
    if (isGoogleVignetteShowing()) event.preventDefault()
  })
}
